module.exports = __webpack_public_path__ + "assets/img/gbeian.d0289dc0.png";